<template>
  <Header>
    <Menu mode="horizontal" theme="dark" @on-select="logOut">
      <div class="layout-nav">
        <MenuItem name="greeting">{{companyName}} 您好</MenuItem>
        <MenuItem name="logOut" class="rightItem" @click="logOut">
          {{ managerName }}
          登出
        </MenuItem>
      </div>
    </Menu>
  </Header>
</template>

<script>
import { getAllCookies, deleteAllCookies } from "@/utilities/cookie";
import Cookies from 'js-cookie'

export default {
  created() {
    const info = getAllCookies();
    this.setUser(info);
  },
  data() {
    return {
      companyName: "",
      managerName: ""
    };
  },
  methods: {
    getItem(name) {
      const data = localStorage.getItem(name);
      return JSON.parse(data);
    },
    setUser(){
      this.companyName = Cookies.get('companyName')
      this.managerName = Cookies.get('managerName')
    },
    logOut(itemName) {
      if (itemName !== "logOut") return;
      deleteAllCookies();
      this.$router.push("/login");
    }
  }
};
</script>

<style lang="scss" scoped>
.rightItem {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue